import {
  SIMILAR_PACKAGES_FAIL,
  SIMILAR_PACKAGES_START,
  SIMILAR_PACKAGES_CREATED_REQUEST,
  SIMILAR_PACKAGES_FINISH,
  SIMILAR_PACKAGES_POPUP_OPENED,
  SIMILAR_PACKAGES_POPUP_CLOSED,
  UPDATE_PACKAGE_ID,
  CREATE_PACKAGE,
  CREATE_PACKAGE_SUCCESS,
  CREATE_PACKAGE_FAIL,
  CLEAR_PREVIOUS_PACKAGE_DATA,
  CLEAR_SEARCH,
  SET_SEARCHER_DATE,
  SET_ADULTS,
  SET_KIDS,
  SET_NIGHTS,
  SIMILAR_PACKAGES_GO_TO_HOTEL,
} from '../constants/similar-packages';

export const similarPackagesFail = (payload) => ({
  type: SIMILAR_PACKAGES_FAIL,
  payload,
});

export const similarPackagesStartAction = () => ({
  type: SIMILAR_PACKAGES_START,
});

export const similarPackagesCreatedRequesAction = (payload) => ({
  type: SIMILAR_PACKAGES_CREATED_REQUEST,
  payload,
});

export const similarPackagesFinishAction = (payload) => ({
  type: SIMILAR_PACKAGES_FINISH,
  payload,
});

export const similarPackagesPopupOpenedAction = () => ({
  type: SIMILAR_PACKAGES_POPUP_OPENED,
});

export const similarPackagesPopupClosedAction = () => ({
  type: SIMILAR_PACKAGES_POPUP_CLOSED,
});

export const similarPackagesGoToHotelAction = () => ({
  type: SIMILAR_PACKAGES_GO_TO_HOTEL,
});

export const updatePackageID = (payload) => ({
  type: UPDATE_PACKAGE_ID,
  payload,
});

// CREATE PACKAGE
export const createPackageAction = (payload) => ({
  type: CREATE_PACKAGE,
  payload,
});

export const createPackageSuccess = (payload) => ({
  type: CREATE_PACKAGE_SUCCESS,
  payload,
});

export const createPackageFail = (payload) => ({
  type: CREATE_PACKAGE_FAIL,
  payload,
});

export const clearPreviousPackageDataAction = () => ({
  type: CLEAR_PREVIOUS_PACKAGE_DATA,
});

// SEARCHER
export const clearSearchAction = () => ({
  type: CLEAR_SEARCH,
});

export const setSearcherDateAction = (payload) => ({
  type: SET_SEARCHER_DATE,
  payload,
});

export const setAdultsAction = (payload) => ({
  type: SET_ADULTS,
  payload,
});

export const setKidsAction = (payload) => ({
  type: SET_KIDS,
  payload,
});

export const setNightsAction = (payload) => ({
  type: SET_NIGHTS,
  payload,
});
